import {Component, input} from '@angular/core';
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {AbstractControl, FormControl, ReactiveFormsModule} from "@angular/forms";
import { AppTooltipComponent } from '../app-tooltip/app-tooltip.component';
import { DialogFormErrorComponent } from '../dialog-form-error/dialog-form-error.component';

@Component({
  selector: 'app-dialog-textarea',
  imports: [
    MatFormField,
    MatInput,
    ReactiveFormsModule,
    MatLabel,
    AppTooltipComponent,
    DialogFormErrorComponent
  ],
  templateUrl: './dialog-textarea.component.html'
})
export class DialogTextareaComponent {
  ctrl = input.required<AbstractControl>();

  label = input<string>();

  hint = input<string>();

  maxLength = input<number>();

  getControl(): FormControl {
    return this.ctrl() as FormControl;
  }
}
